import { CONSENT_CATEGORIES, type ConsentCategory, type ConsentState } from './consent';

export interface CookiebotLike {
  hasResponse?: unknown;
  consent?: Partial<Record<ConsentCategory, unknown>>;
}

export interface CookiebotEventTarget extends EventTarget {
  Cookiebot?: CookiebotLike;
}

export interface CookiebotDecision {
  decided: boolean;
  consent: ConsentState;
}

const deniedConsent = (): ConsentState => ({
  necessary: true,
  preferences: false,
  statistics: false,
  marketing: false,
});

/** Normaliza a fronteira global do Cookiebot sem presumir aceite em dados ausentes ou malformados. */
export function readCookiebotDecision(cookiebot: CookiebotLike | undefined): CookiebotDecision {
  if (cookiebot?.hasResponse !== true) {
    return { decided: false, consent: deniedConsent() };
  }

  const consent = deniedConsent();
  for (const category of CONSENT_CATEGORIES) {
    if (cookiebot.consent?.[category] === true) consent[category] = true;
  }
  consent.necessary = true;

  return { decided: true, consent };
}

/**
 * Escuta a fonte autoritativa do web. A leitura imediata cobre o caso em que o script no `<head>`
 * resolveu o consentimento antes de o React montar.
 */
export function subscribeToCookiebotConsent(
  source: CookiebotEventTarget,
  onDecision: (decision: CookiebotDecision) => void,
): () => void {
  const emitDecision = () => onDecision(readCookiebotDecision(source.Cookiebot));
  source.addEventListener('CookiebotOnConsentReady', emitDecision);

  const currentDecision = readCookiebotDecision(source.Cookiebot);
  if (currentDecision.decided) onDecision(currentDecision);

  return () => source.removeEventListener('CookiebotOnConsentReady', emitDecision);
}
